import(/* webpackMode: "eager", webpackExports: ["ChatHistory"] */ "/mnt/c/shipany/ZestyGen/src/shared/blocks/chat/history.tsx");
